import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams, useOutletContext } from 'react-router-dom';
import CreateMissionHeaderAndTitleRow from "../components/CreateMissionHeaderAndTitleRow";
import { FormField, NumberField, IntegerField, DropdownQuestion, DropdownOption } from "../../common_components/Forms";
import CreationFooter from "../components/CreationFooter";
import { useAlert } from 'react-alert'
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { ResearcherContext } from "../../../../ResearcherContext";
import { updatePrice } from "../components/PriceDisplay";


// Api Calls
import MissionsAPI from "../../../api/api_calls/MissionAPI";


function SurveyDetails(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [submitInProcess, setSubmitInProcess] = useState(false);
    const [loadingMission, setLoadingMission] = useState(true);

    const [missionType, loadingMissionType, nextPage, backPage] = [props.missionType, props.loadingMissionType, props.nextPage, props.backPage]
    const { researcher, setResearcher, refreshResearcher } = useContext(ResearcherContext);


    const [numberRespondents, setNumberRespondents] = useState(-1);

    const numberRespondentsTooltip = "The total number of survey responses you'd like to have"

    const mayProgress = numberRespondents > 0

    const [price, setPrice] = useState("-");
    const [totalPrice, setTotalPrice] = useState("-");

    function updatePriceWrapper() {
        updatePrice(setPrice, setTotalPrice, missionId, navigate, alert);
    }


    // -------------------------------------
    // ------ Use Effects ---------------
    // -------------------------------------

    useEffect(() => {

        async function getSessionDetails() {
            const result = await MissionsAPI.show(missionId, navigate);

            if (result.success) {
                setNumberRespondents(result.mission.num_total_spots * 1);
                setLoadingMission(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
            // Enable tooltips
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
        }

        updatePriceWrapper();
        getSessionDetails();
        props.setAllowedToProgress(mayProgress)
    }, []);


    useEffect(() => {
        props.setAllowedToProgress(mayProgress)
    }, [mayProgress]);

    // -------------------------------------
    // ------ Event Handlers ---------------
    // -------------------------------------

    function onClickBack() {
        navigate(backPage, { state: { missionId: missionId } })
    }

    // Create the mission and move to the next page.
    async function createSessionDetails({ numberRespondentsData = numberRespondents }) {
        setSubmitInProcess(true);
        const result = await MissionsAPI.updateSurveyDetails(missionId, numberRespondentsData, navigate);

        if (!result.success) {
            alert.show(result.error, { type: 'error' })
        }
        setSubmitInProcess(false);
    }

    function onClickSubmit(event) {
        event.preventDefault();

        // Vet the answers all make sense.
        if (numberRespondents <= 0) {
            alert.show("Please select a number of respondents", { type: 'error' })
            return;
        }

        navigate(nextPage, { state: { missionId: missionId } });
    }

    // -------------------------------------
    // ------ Helper Functions ---------------
    // -------------------------------------

    function onNumberRespondentsChange(event) {
        setNumberRespondents(event.target.value);
        createSessionDetails({ numberRespondentsData: event.target.value });
    }




    return (
        <div className="create-mission-primary-content-container">
            <CreateMissionHeaderAndTitleRow title={"Survey Details"} subtitle="How many respondents do you want in your survey?" price={price} totalPrice={totalPrice} hidePrice={true} />
            <SessionDetailsForm>
                <div className="session-details-container">
                    {loadingMission ? (<div className="centered-loading"> <CenteredLoadingIcon /> </div>) :
                        (<>
                            <div className="session-details-form-container">
                                <IntegerField label="Number of Respondents" name="number_of_respondents" id="numrespondents"
                                    placeholder="Enter number" onChange={onNumberRespondentsChange}
                                    tooltip={numberRespondentsTooltip} min={1} step={1}
                                    value={numberRespondents >= 0 ? numberRespondents : ""} />
                            </div>
                            <CreationFooter buttonText="Next" onClickBack={onClickBack} onClickSubmit={onClickSubmit} submitLoading={submitInProcess} />
                        </>
                        )}
                </div>
            </SessionDetailsForm>
        </div>

    )
}

function SessionDetailsForm(props) {
    return (
        <form className="session-details-form">
            {props.children}
        </form>
    )
}

export default SurveyDetails;